/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://statefulcoders.com/product/material-dashboard-react
* Copyright 2025 Stateful Coders (https://https://statefulcoders.com)

Coded by https://statefulcoders.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 React Base Styles
import colors from "assets/theme/base/colors";
import borders from "assets/theme/base/borders";
import typography from "assets/theme/base/typography";
import breakpoints from "assets/theme/base/breakpoints";

// Material Dashboard 2 React helper functions
import pxToRem from "assets/theme/functions/pxToRem";

const { inputBorderColor, info, grey, transparent } = colors;
const { borderRadius } = borders;
const { size } = typography;

const inputOutlined = {
  styleOverrides: {
    root: {
      backgroundColor: transparent.main,
      fontSize: size.sm,
      borderRadius: borderRadius.md,

      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: inputBorderColor,
      },

      "&.Mui-focused": {
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: info.main,
        },
      },

      // Mobile optimizations
      [`@media (max-width: ${breakpoints.values.sm}px)`]: {
        fontSize: size.md,

        "& .MuiInputBase-input": {
          padding: `${pxToRem(14)} ${pxToRem(12)}`,
          minHeight: pxToRem(20), // Touch-friendly height
        },
      },
    },

    notchedOutline: {
      borderColor: inputBorderColor,
    },

    input: {
      color: grey[700],
      padding: pxToRem(12),
      backgroundColor: transparent.main,

      // Mobile touch-friendly sizing
      [`@media (max-width: ${breakpoints.values.sm}px)`]: {
        padding: `${pxToRem(14)} ${pxToRem(12)}`,
        fontSize: size.md,
        minHeight: pxToRem(20),
      },
    },

    inputSizeSmall: {
      fontSize: size.xs,
      padding: pxToRem(10),

      [`@media (max-width: ${breakpoints.values.sm}px)`]: {
        fontSize: size.sm,
        padding: `${pxToRem(12)} ${pxToRem(10)}`,
        minHeight: pxToRem(18),
      },
    },

    multiline: {
      color: grey[700],
      padding: 0,
    },
  },
};

export default inputOutlined;
